// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expenses-header {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 1px 0;
  justify-content: flex-end;
}

.expense-create-box {
  padding: 10px;
  border: 1px solid #0860e63b;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
}

.expense-create-sub-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.expense-submit-button {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}

.expense-file-upload-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  margin-bottom: 0.5rem;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/expenses/components/expenseHeader/expenseHeader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;AACb","sourcesContent":[".expenses-header {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 1px 0;\n  justify-content: flex-end;\n}\n\n.expense-create-box {\n  padding: 10px;\n  border: 1px solid #0860e63b;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.expense-create-sub-box {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n}\n\n.expense-submit-button {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.expense-file-upload-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem;\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n  margin-bottom: 0.5rem;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
